import 'what-input';
// eslint-disable-next-line import/extensions,import/no-unresolved
import initMaterialize from './form/index';
import './foundation/index';
import owlEyes from './owl-eyes';

owlEyes();
initMaterialize();
